import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export const CreateRepSchema = zod.RepSchema.omit({
    id: true,
    createdAt: true,
    empresaId: true,
    updatedAt: true,
})

export const UpdateRepSchema = zod.RepSchema.omit({
    createdAt: true,
    updatedAt: true,
})

export type Marca = z.infer<typeof zod.MarcaSchema>

const funcionarioRepsSchema = zod.FuncionarioRepsSchema.omit({
    __typename: true,
    createdAt: true,
})

export type FuncionarioReps = z.infer<typeof funcionarioRepsSchema>

export type Reps = z.infer<typeof zod.RepSchema> & {
    FuncionarioReps: FuncionarioReps[]
}

const service = new ApiService<Reps>('reps')

export interface EnviarFuncionariosRep {
    repId: number
    funcionarioIds?: number[]
}

export interface EnviarFuncionariosRepResponse {
    enviados: number
    success: boolean
    message?: string
}

export const reps = Object.assign(service, {
    marca: new ApiService<Marca>('reps/marcas'),
    funcionarios: new ApiService<FuncionarioReps>('reps/funcionarios'),
    enviar: new ApiService<
        EnviarFuncionariosRep,
        EnviarFuncionariosRepResponse
    >('reps/funcionarios/enviar'),
})

export enum Marcas {
    NULL,
    GERTEC_G3,
    GERTEC_G1_G2,
    REP_TERMINAL,
    CONTROLID,
    TOP_DATA,
    RW_TECH,
    TOP_DATA_INNER_NETBIO,
    TOP_DATA_INNER,
    HENRY_HEXA,
    CONTROL_IDX,
    DIXI_SIND_NOX,
    TRILOBIT,
    KEY_PASS,
    TELEMATICA,
    HENRY_SUPER_FACIL,
}
